module.exports = __webpack_public_path__ + "static/media/coinbase.75da5133.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/coinbase.png
// module id = 286
// module chunks = 0